export const changeMarginType = value => ({
  type: '@@redux-ui/UPDATE_UI_STATE',
  payload: {
    key: ['EditorToolsUI'],
    name: 'marginType',
    value,
  },
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/marginType.js